(function () {
  const Collection = {
    init() {
      this.initSort();
      this.initFilterDrawer();
    },

    initSort() {
      document.querySelectorAll('[data-sort-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const params = new URLSearchParams(window.location.search);
          params.set('sort_by', select.value);
          window.location.search = params.toString();
        });
      });
    },

    initFilterDrawer() {
      const drawer = document.querySelector('[data-filter-drawer]');
      const toggle = document.querySelector('[data-filter-toggle]');
      if (!drawer || !toggle) return;

      toggle.addEventListener('click', () => {
        Branzos.openDrawer(drawer);
        toggle.setAttribute('aria-expanded', 'true');
      });

      drawer.querySelectorAll('[data-drawer-close]').forEach((btn) => {
        btn.addEventListener('click', () => {
          Branzos.closeDrawer(drawer);
          toggle.setAttribute('aria-expanded', 'false');
        });
      });

      drawer.querySelectorAll('.filter-option').forEach((link) => {
        link.addEventListener('click', () => {
          Branzos.closeDrawer(drawer);
        });
      });
    },
  };

  window.ShopifyCollection = Collection;
  Branzos.onLoad(() => Collection.init());
})();
